export default {
    data() {
        return {
            width: '',
            height: '',
            left: '',
            top: ''
        }
    },
    computed: {
        style () {
            let css = {}
            if (this.width) {css.width = this.width + 'px'}
            if (this.height) {css.height = this.height + 'px'}
            if (this.left) {css.left = this.left + 'px'}
            if (this.top) {css.top = this.top + 'px'}
            return css
        }
    }
}


// WEBPACK FOOTER //
// ./source/base/layer.js